import { render, staticRenderFns } from "./FileUploadClient.vue?vue&type=template&id=36e7e7f8"
import script from "./FileUploadClient.vue?vue&type=script&lang=js"
export * from "./FileUploadClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports